const versionMap = {
  base: sessionStorage.getItem('paas_sdk_base_version') || '1.2.8-beta.3',
  player: sessionStorage.getItem('paas_sdk_player_version') || '2.7.2-beta.2',
  chat: sessionStorage.getItem('paas_sdk_chat_version') || '2.1.12',
  interaction: sessionStorage.getItem('paas_sdk_interaction_version') || '3.2.7-beta.1',
  doc: sessionStorage.getItem('paas_sdk_doc_version') || '3.5.12-beta.1',
  exam: sessionStorage.getItem('paas_sdk_exam_version') || '1.1.0',// 快问快答
  questionnaire: sessionStorage.getItem('paas_sdk_questionnaire_version') || '1.3.0',// 问卷、表单
}


export default {
  //基础sdk
  base: {
    url: `//test01-static.vhallyun.com/jssdk/vhall-jssdk-base/${versionMap.base}/vhall-msg-${versionMap.base}.js`
  },
  //播放器sdk
  player: {
    name: 'VhallPlayer',
    url: `//test01-static.vhallyun.com/jssdk/vhall-jssdk-player/${versionMap.player}/vhall-jssdk-player-${versionMap.player}.js`
  },
  //聊天sdk
  chat: {
    name: 'VhallChat',
    url: `//test01-static.vhallyun.com/jssdk/vhall-jssdk-chat/${versionMap.chat}/vhall-jssdk-chat-${versionMap.chat}.js`
  },
  //互动sdk
  interaction: {
    name: 'VhallRTC',
    url: `//test01-static.vhallyun.com/jssdk/vhall-jssdk-interaction/${versionMap.interaction}/vhall-jssdk-interaction-hybrid-${versionMap.interaction}.js`
  },
  //文档sdk
  doc: {
    name: 'VHDocSDK',
    url: `//test01-static.vhallyun.com/jssdk/vhall-jssdk-doc/${versionMap.doc}/vhall-jssdk-doc-${versionMap.doc}.js`
  },
  questionnaire: {
    name: 'VHall_Questionnaire_Service',
    url: `https://t-alistatic01.e.vhall.com/common-static/middle/questionnaire/${versionMap.questionnaire}/questionnaire_service.js`,
    defer: true // 新增属性，延迟执行
  },
  exam: {
    name: "ExamTemplateServer",
    url: `https://t-alistatic01.e.vhall.com/common-static/vhall-form/${versionMap.exam}/vhall-form-vue.js`
  }
};
